<template>
  <div class="alarm-center">
    <div class="general-container">
      <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
        <el-tab-pane label="实时事件" name="0">
          <el-form ref="realEventQueryForm" class="pagination-table-query-form" :inline="true"
                   @keyup.enter.native="handleRealEventFormQuery()">
            <el-form-item label="告警状态" class="right-vertical-line pr15">
              <el-checkbox-group v-model="realEventTableQueryParams.alarmStates">
                <el-checkbox v-for="alarmState in $type.alarmStates" :key="alarmState.id" :label="alarmState.id">
                  {{alarmState.name}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="确认状态">
              <el-checkbox-group v-model="realEventTableQueryParams.handleStates">
                <el-checkbox v-for="handleState in $type.handleStates" :key="handleState.id" :label="handleState.id">
                  {{handleState.name}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item>
              <el-button @click="handleRealEventFormQuery()" type="primary">刷 新</el-button>
              <el-button @click="resetRealEventQueryForm()">重 置</el-button>
            </el-form-item>
          </el-form>
          <div class="pagination-table-button-container">
            <el-button type="primary" @click="handleRealEventHandle()" :disabled="!realEventTableSelectedIds.length">批量确认</el-button>
          </div>
          <div class="pagination-table-container">
            <el-table :data="realEventTableData"
                      ref="realEventTable"
                      border highlight-current-row
                      element-loading-background="rgba(255, 255, 255, 0.8)"
                      element-loading-spinner="el-icon-loading"
                      element-loading-text="努力加载中..."
                      style="width: 100%"
                      @selection-change="handleRealEventTableSelectionChange"
                      @current-change="handleRealEventTableCurrentChange">
              <el-table-column type="selection" width="40"></el-table-column>
              <el-table-column label="序号" type="index" width="60"></el-table-column>
              <el-table-column label="区域" prop="regionId" :show-overflow-tooltip="true">
                <template slot-scope="scope">{{ getNameById(scope.row.regionId, $globalData.regions) }}</template>
              </el-table-column>
              <el-table-column label="名称" prop="resourceName" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column label="告警状态" prop="alarmState" width="90">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.alarmState === 1 ? 'danger'
                  : scope.row.alarmState === 2 ? 'warning'
                  :'primary'">
                    {{scope.row.alarmStateText}}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="告警级别" prop="alarmLevel" width="100">
                <template slot-scope="scope">{{ getNameById(scope.row.alarmLevel, $type.alarmLevels) }}</template>
              </el-table-column>
              <el-table-column label="数值" prop="workStateText" width="100"></el-table-column>
              <el-table-column label="事件类型" prop="eventTypeText" width="120"></el-table-column>
              <el-table-column label="事件子类型" prop="eventSubTypeText" width="120"></el-table-column>
              <el-table-column label="事件触发时间" prop="happenTime" width="160">
                <template slot-scope="scope"> {{strDateTimeFromSTime_t(scope.row.happenTime)}}</template>
              </el-table-column>
              <el-table-column label="正常区间" prop="alarmRuleText" width="100"></el-table-column>
              <el-table-column label="确认状态" prop="handled" width="80">
                <template slot-scope="scope">
                  <el-tag :type="(scope.row.alarmLevel === 0 || scope.row.alarmState !== 1 || scope.row.handled === 1) ? 'primary':'warning'">
                    {{(scope.row.alarmLevel === 0 || scope.row.alarmState !== 1) ? '--' : getNameById(scope.row.handled, $type.handleStates)}}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="130">
                <template slot-scope="scope">
                  <el-button
                    class="col-btn"
                    type="text"
                    icon="el-icon-view"
                    @click="handleRealEventView(scope.row)"
                  >查看
                  </el-button>
                  <el-button
                    class="col-btn"
                    type="text"
                    icon="el-icon-s-check"
                    :disabled="(scope.row.alarmLevel === 0 || scope.row.alarmState !== 1)"
                    @click="handleRealEventHandle(scope.row)"
                  >确认
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination v-show="realEventTableTotalRow > realEventTableQueryParams.pageSize"
                           background
                           @current-change="handleRealEventCurrentPageChange"
                           @size-change="handleRealEventPageSizeChange"
                           :current-page.sync="realEventTableQueryParams.pageNum"
                           :page-sizes="[5, 10, 15, 20, 30, 50, 100]"
                           :page-size.sync="realEventTableQueryParams.pageSize"
                           prev-text="上一页"
                           next-text="下一页"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="realEventTableTotalRow">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="历史事件" name="1">
          <el-form ref="historyEventQueryForm" class="pagination-table-query-form" :inline="true"
                   @keyup.enter.native="handleHistoryEventFormQuery()">
            <el-form-item label="告警状态" class="right-vertical-line pr15">
              <el-checkbox-group v-model="historyEventTableQueryParams.alarmStates">
                <el-checkbox v-for="alarmState in $type.alarmStates" :key="alarmState.id" :label="alarmState.id">
                  {{alarmState.name}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="确认状态" class="right-vertical-line pr15">
              <el-checkbox-group v-model="historyEventTableQueryParams.handleStates">
                <el-checkbox v-for="handleState in $type.handleStates" :key="handleState.id" :label="handleState.id">
                  {{handleState.name}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="事件触发时间">
              <uni-date-range-picker
                v-model="historyEventDates"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </uni-date-range-picker>
            </el-form-item>
            <el-form-item>
              <el-button @click="handleHistoryEventFormQuery()" type="primary">查 询</el-button>
              <el-button @click="resetHistoryEventQueryForm()">重 置</el-button>
            </el-form-item>
          </el-form>
          <div class="pagination-table-button-container">
            <el-button type="primary" @click="handleHistoryEventHandle()" :disabled="!historyEventTableSelectedIds.length">批量确认</el-button>
          </div>
          <div class="pagination-table-container">
            <el-table :data="historyEventTableData"
                      ref="historyEventTable"
                      v-loading="loading"
                      border highlight-current-row
                      element-loading-background="rgba(255, 255, 255, 0.8)"
                      element-loading-spinner="el-icon-loading"
                      element-loading-text="努力加载中..."
                      style="width: 100%"
                      @selection-change="handleHistoryEventTableSelectionChange"
                      @current-change="handleHistoryEventTableCurrentChange">
              <el-table-column type="selection" width="40"></el-table-column>
              <el-table-column label="序号" type="index" width="60"></el-table-column>
              <el-table-column label="区域" prop="regionId" :show-overflow-tooltip="true">
                <template slot-scope="scope">{{ getNameById(scope.row.regionId, $globalData.regions) }}</template>
              </el-table-column>
              <el-table-column label="名称" prop="resourceName" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column label="告警状态" prop="alarmState" width="90">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.alarmState === 1 ? 'danger'
                  : scope.row.alarmState === 2 ? 'warning'
                  :'primary'">
                    {{scope.row.alarmStateText}}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="告警级别" prop="alarmLevel" width="100">
                <template slot-scope="scope">{{ getNameById(scope.row.alarmLevel, $type.alarmLevels) }}</template>
              </el-table-column>
              <el-table-column label="数值" prop="workStateText" width="100"></el-table-column>
              <el-table-column label="事件类型" prop="eventTypeText" width="120"></el-table-column>
              <el-table-column label="事件子类型" prop="eventSubTypeText" width="120"></el-table-column>
              <el-table-column label="事件触发时间" prop="happenTime" width="160">
                <template slot-scope="scope"> {{strDateTimeFromSTime_t(scope.row.happenTime)}}</template>
              </el-table-column>
              <el-table-column label="正常区间" prop="alarmRuleText" width="100"></el-table-column>
              <el-table-column label="确认状态" prop="handled" width="80">
                <template slot-scope="scope">
                  <el-tag :type="(scope.row.alarmLevel === 0 || scope.row.alarmState !== 1 || scope.row.handled === 1) ? 'primary':'warning'">
                    {{(scope.row.alarmLevel === 0 || scope.row.alarmState !== 1) ? '--' : getNameById(scope.row.handled, $type.handleStates)}}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="130">
                <template slot-scope="scope">
                  <el-button
                    class="col-btn"
                    type="text"
                    icon="el-icon-view"
                    @click="handleHistoryEventView(scope.row)"
                  >查看
                  </el-button>
                  <el-button
                    class="col-btn"
                    type="text"
                    icon="el-icon-s-check"
                    :disabled="scope.row.alarmLevel === 0 || scope.row.alarmState !== 1 || scope.row.handled === 1"
                    @click="handleHistoryEventHandle(scope.row)"
                  >确认
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination v-show="historyEventTableTotalRow > historyEventTableQueryParams.pageSize"
                           background
                           @current-change="handleHistoryEventCurrentPageChange"
                           @size-change="handleHistoryEventPageSizeChange"
                           :current-page.sync="historyEventTableQueryParams.pageNum"
                           :page-sizes="[5, 10, 15, 20, 30, 50, 100]"
                           :page-size.sync="historyEventTableQueryParams.pageSize"
                           prev-text="上一页"
                           next-text="下一页"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="historyEventTableTotalRow">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!--显示告警事件信息-->
    <show-alarm-event v-if="showRealEventModalOpen" :modalOpen="showRealEventModalOpen" :alarmEvent="realEventTableCurrentRow" @submit="handleShowRealEventModalSubmit" @cancel="handleShowRealEventModalCancel"></show-alarm-event>

    <!--确认告警事件弹窗-->
    <handle-alarm-event-Modal v-if="handleRealAlarmEventModalOpen" :modalOpen="handleRealAlarmEventModalOpen" :alarmEvent="realEventTableCurrentRow" @submit="handleHandleRealAlarmEventModalSubmit" @cancel="handleHandleRealAlarmEventModalCancel"></handle-alarm-event-Modal>

    <!--显示告警事件信息-->
    <show-alarm-event v-if="showHistoryEventModalOpen" :modalOpen="showHistoryEventModalOpen" :alarmEvent="historyEventTableCurrentRow" @submit="handleShowHistoryEventModalSubmit" @cancel="handleShowHistoryEventModalCancel"></show-alarm-event>

    <!--确认告警事件弹窗-->
    <handle-alarm-event-Modal v-if="handleHistoryAlarmEventModalOpen" :modalOpen="handleHistoryAlarmEventModalOpen" :alarmEvent="historyEventTableCurrentRow" @submit="handleHandleHistoryAlarmEventModalSubmit" @cancel="handleHandleHistoryAlarmEventModalCancel"></handle-alarm-event-Modal>

  </div>
</template>

<script type="text/ecmascript-6">
import AlarmCenter from './AlarmCenter.js'

export default AlarmCenter
</script>

<style lang="scss">
  @import "AlarmCenter";
</style>



// WEBPACK FOOTER //
// src/views/home/alarmCenter/AlarmCenter.vue